import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowRight, ExternalLink } from 'lucide-react';

const ChatMessage = ({ message }) => {
  const navigate = useNavigate();
  const isBot = message.sender === 'bot';

  const handleNavigation = (path) => {
    navigate(path);
  };

  // Parse navigation hints from the message
  const getNavigationButtons = () => {
    if (!message.navigation) return null;
    
    return (
      <div style={{ 
        marginTop: '0.75rem', 
        display: 'flex', 
        flexWrap: 'wrap', 
        gap: '0.5rem' 
      }}>
        {message.navigation.map((nav, idx) => (
          <button
            key={idx}
            onClick={() => handleNavigation(nav.path)}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '0.5rem',
              padding: '0.5rem 1rem',
              background: 'linear-gradient(135deg, #0277bd 0%, #01579b 100%)',
              color: 'white',
              border: 'none',
              borderRadius: '20px',
              fontSize: '0.85rem',
              fontWeight: 600,
              cursor: 'pointer',
              transition: 'all 0.2s'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-2px)';
              e.currentTarget.style.boxShadow = '0 4px 12px rgba(2, 119, 189, 0.3)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = 'none';
            }}
          >
            {nav.label}
            <ArrowRight size={14} />
          </button>
        ))}
      </div>
    );
  };

  // Format message text with line breaks
  const formatText = (text) => {
    return text.split('\n').map((line, idx) => (
      <React.Fragment key={idx}>
        {line}
        {idx < text.split('\n').length - 1 && <br />}
      </React.Fragment>
    ));
  };

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: isBot ? 'flex-start' : 'flex-end',
      maxWidth: '85%',
      alignSelf: isBot ? 'flex-start' : 'flex-end'
    }}>
      {/* Sender Label (for bot only) */}
      {isBot && (
        <div style={{
          fontSize: '0.75rem',
          color: '#78909c',
          marginBottom: '0.25rem',
          marginLeft: '0.5rem'
        }}>
          Dr. Veena
        </div>
      )}
      
      {/* Message Bubble */}
      <div style={{
        padding: '0.875rem 1rem',
        borderRadius: '16px',
        borderBottomLeftRadius: isBot ? '4px' : '16px',
        borderBottomRightRadius: isBot ? '16px' : '4px',
        background: isBot ? 'white' : 'linear-gradient(135deg, #0277bd 0%, #01579b 100%)',
        color: isBot ? '#1e293b' : 'white',
        boxShadow: '0 1px 4px rgba(0,0,0,0.08)',
        fontSize: '0.95rem',
        lineHeight: 1.5
      }}>
        {formatText(message.text)}
        {isBot && getNavigationButtons()}
      </div>
      
      {/* Timestamp */}
      <div style={{
        fontSize: '0.7rem',
        color: '#9e9e9e',
        marginTop: '0.25rem',
        marginLeft: isBot ? '0.5rem' : '0',
        marginRight: isBot ? '0' : '0.5rem'
      }}>
        {new Date(message.timestamp).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
      </div>
    </div>
  );
};

export default ChatMessage;
